import { Box, Card, Container, Divider, Stack, Toolbar, Typography } from '@mui/material'
import React from 'react'
import HPCtimeline from './HPCtimeline'
import AboutUs from '../Pages/AboutUs'
import ResearchFocus from '../Pages/ResearchFocus'
import Footer from './Footer'
import { Scale } from '@mui/icons-material'

export default function Home() {

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 720 ? true : false)

  //choose the screen size 
  const handleResize = () => {
    if (window.innerWidth < 720) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  return (
    <React.Fragment>
      <Box flexGrow={0}>
        <Box sx={{
          backgroundColor: '#133F49',
        }}>
          <Container fluid sx={{
            backgroundColor: '#133F49',
            maxHeight: { xs: "auto", md: "90vh" },
            maxWidth: { xs: "auto", md: "135vh", xl: "auto" },
            // marginTop:"-10%"
          }}>
            <img src={"/images/home_images/home_lifecycle v9.png"} style={{
              width: "100%",
              position: 'relative',

            }} loading="eager" />
          </Container>
        </Box>
        <img src={"/images/home_images/wave.svg"} style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          marginBottom: "-10%"

        }} loading="eager" />
        <AboutUs />
        <br /><br />
        <ResearchFocus />
      </Box>

      <img src="/images/logos/Logo_cropped.png" width="120" color='black' style={{ position: 'relative' }} />

      <Toolbar />
      <Footer />
    </React.Fragment >
  )
}
